import type { ExtensionConfig } from '@goto/shell'

const extensionConfig: ExtensionConfig = {
  id: '@goto/network-measurements',
  url: new URL('/experiences/networkmeasurements/extension.js', location.origin),
}

export default extensionConfig
